import { ValueGetterFunc } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { getOffHoursNextRun } from "@/components/pages/automations/off-hours/utils/helpers/getOffHoursNextRun";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const offHoursNextRunValueGetter: ValueGetterFunc<OffHoursSchedule> = ({
  data,
}) => {
  if (!data) {
    return;
  }

  const { status, metadata } = data;

  if (status === "inactive") {
    return "Inactive";
  }

  const { nextRun, type } = getOffHoursNextRun(
    metadata.next_stop_run_at,
    metadata.next_start_run_at,
    status,
  );

  if (!nextRun) {
    return "Never";
  }

  return `${(type ?? "").toUpperCase()} | ${formatDate(nextRun, {
    type: "date",
  })} ${formatDate(nextRun, {
    type: "time",
  })}`;
};
